// src/shared/visible-poll.js - a polling timer that rests while the page is hidden (v136.8).
//
// The Worker audit of 16 Oct 2026 found three background loops (missed calls, the store badge
// shelf, the add-on tally) still calling the Worker every few minutes from tabs nobody was looking
// at: a till left on another app, a phone in a pocket, a laptop with the lid down. Nobody can see
// what they fetch, so the fetch is wasted.
//
// visiblePoll(fn, ms) is setInterval(fn, ms) with two rules:
//   - a tick that fires while document.visibilityState is not 'visible' is skipped, and noted;
//   - when the page becomes visible again after a skipped tick, fn runs ONCE straight away, so
//     nothing on screen is staler than it would have been with the timer running all along.
//
// Use it only for loops whose answer is for the eyes. The version check (src/version) and the
// pay-critical clock checks keep their own timers on purpose.

export function visiblePoll(fn, ms, doc) {
  const d = doc || (typeof document !== 'undefined' ? document : null);
  let missed = false;
  const isVisible = () => !d || d.visibilityState === undefined || d.visibilityState === 'visible';
  const tick = () => {
    if (!isVisible()) { missed = true; return; }
    fn();
  };
  const timer = setInterval(tick, ms);
  const onVisibility = () => {
    if (missed && isVisible()) { missed = false; fn(); }
  };
  if (d && typeof d.addEventListener === 'function') d.addEventListener('visibilitychange', onVisibility);
  return {
    timer,
    stop() {
      clearInterval(timer);
      if (d && typeof d.removeEventListener === 'function') d.removeEventListener('visibilitychange', onVisibility);
    },
  };
}
